<template>
  <div ref="wrapper" class="wrapper" ondragstart="return false;">
    <transition-group
    ref="msgList"
    tag="div"
    name="msg-fade"
    v-on:after-enter="afterEnter"
    id="scroller">
        <div class="pull-refresh" key="pull">{{refreshText}}</div>
        <message-item v-for="item in msgList" :key="item.msgid" :msgObj="item"/>
    </transition-group>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex";
import MessageItem from "../components/MessageItem"
import util from '../utils/util'

window.myScroller = null;  // 调试时使用
var myScrollInterval = null;

export default {
  name: "message-list",
  components: {
    MessageItem
  },
  data() {
    return {
      scrollerHeight: 0,
      preTime: 0,
      nextTime: 0,
      refreshText: '下拉加载历史记录',
      historyLen: 0,
      isFirstHistory: true,
      scrolling: false,
      scrollType: ''
    }
  },
  computed: {
    ...mapGetters({
      msgList1: "msgList",
      msgList2: 'msgHistoryList',
      historyEmpty: 'historyEmpty'
    }),
    msgList: function () {
      return [].concat(this.msgList2).concat(this.msgList1)
    }
  },
  watch: {
    msgList1 () {
        this.scrollType = "msgListScrollToEnd";
    },
    msgList2 (val) {
        if (this.isFirstHistory) {
          this.scrollType = "msgListScrollToEnd";
          this.isFirstHistory = false;
          this.historyLen = val.length;
        } else {
          if (val.length !== this.historyLen) {
            this.scrollType = val.length - this.historyLen;
          }
          this.historyLen = val.length;
        }
    },
    historyEmpty() {
      this.$nextTick(() => {
        this.refreshText = "历史记录只能显示到这啦";
      })
    }
  },
  updated() {
    this.afterEnter();
  },
  methods: {
    afterEnter() {
      this.$nextTick(() => {
        if (!this.scrolling && !!this.scrollType) {
          if (typeof this.scrollType == "number") {
            Bus.$emit("msgListScrollTo", this.scrollType)
          } else {
            Bus.$emit(this.scrollType)
          }
        }
      })
    },
    initImgClickEvent() {
      this.$refs.wrapper.onclick = (self) => {
        var $selfEl = self.target
        var w = $selfEl.getAttribute("imgwidth");
        var h = $selfEl.getAttribute("imgheight")
        if ($selfEl.src && w && h) {
          var imgObj = {
            src: $selfEl.src,
            w: w,
            h: h
          }
          this.$imagePreview([imgObj])
        }
      }
    }
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.initImgClickEvent()
      myScroller = new IScroll(this.$refs.wrapper, {
        probeType: 2,
        preventDefault: false,
        mouseWheel: true,
        click: true,
        tap: false,
		    scrollbars:true,
      });

      myScroller.on('scrollStart', () => {
        if (!self.historyEmpty) {
          self.refreshText = "下拉加载历史记录"
        }
        this.scrollType = '';
        self.scrolling = true;
      })

      myScroller.on('scroll', () => {
        if (!self.historyEmpty) {
          if (myScroller.y > 70) {
            self.refreshText = "释放立即加载";
            myScroller.minScrollY = 70;
          } else {
            self.refreshText = "下拉加载历史记录";
            myScroller.minScrollY = 0;
          }
        }
      })

      myScroller.on('scrollEnd', (ev) => {
        if (!self.historyEmpty) {
          if (myScroller.y >= 70) {
            self.refreshing = true;
            self.refreshText = "正在努力加载中...";
            Bus.$emit("getClientHistoryMessages", function () {
              self.refreshText = "加载完成";
              self.scrolling = false;
            });
          } else {
              self.scrolling = false;
          }
        } else {
          self.scrolling = false;
        }
      })

      // 定时刷新，防止图片加载页面高度变化，滚动出现问题
      myScrollInterval = setInterval(() => {
        if(this.scrolling) {return;}
        myScroller.refresh();
      }, 300)

      // 滚动到制定div，100ms内只调用一次
      var scrollToElement = util.debounce((index) => {
        if (index) {
            myScroller.refresh();
            myScroller.scrollToElement(document.querySelectorAll("#scroller>div")[index], 0);
          }
      }, 100, true)

      Bus.$on("msgListScrollTo", scrollToElement);

      // 滚动到底部，100ms内只调用一次
      var scrollToEnd = util.debounce((time) => {
        time = time || 300;   // 默认300毫秒
        myScroller.refresh();
        myScroller.scrollTo(0, myScroller.wrapperHeight - myScroller.scrollerHeight, time);
      }, 100, true)

      Bus.$on("msgListScrollToEnd", scrollToEnd);

      Bus.$on("msgListScrollRefresh", () => {
          myScroller.refresh();
      });
    })
  },
  beforeDestroy() {
    myScrollInterval && clearInterval(myScrollInterval)
  }
};

</script>

<style scoped>
.wrapper {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 10px;
  width: 100%;
  overflow: hidden;
}

#scroller {
	position: absolute;
	z-index: 1;
	-webkit-tap-highlight-color: rgba(0,0,0,0);
	width: 100%;
	-webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	-ms-transform: translateZ(0);
	-o-transform: translateZ(0);
	transform: translateZ(0);
  -webkit-touch-callout: none;
  padding: 0 10px 40px;
  box-sizing: border-box;
}

.pull-refresh{
  position: absolute;
  top: -40px;
  text-align: center;
  color: #999;
  font-size: 15px;
  left: 0;
  right: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/MessageList.1.vue